export const SUPPLY_LEVELS = [
  { key: 'preparatoire', label: 'Préparatoire' },
  { key: '1ere', label: '1ère année' },
  { key: '2eme', label: '2ème année' },
  { key: '3eme', label: '3ème année' },
  { key: '4eme', label: '4ème année' },
  { key: '5eme', label: '5ème année' },
  { key: '6eme', label: '6ème année' }
];

export const SUPPLY_SECTIONS = [
  'Fournitures communes',
  'مجال اللغة العربية',
  'مجال العلوم',
  'مجال التربية',
  'مجال اللغات'
];

export const DEFAULT_SUBJECTS = [
  '',
  'اللغة العربية',
  'العلوم',
  'التربية الإسلامية',
  'التربية الموسيقية',
  'التربية المدنية',
  'التاريخ والجغرافيا',
  'Français',
  'English'
];

// Kept for backward compatibility with lists created with the first version.
export const SUPPLY_CATEGORIES = SUPPLY_SECTIONS;

const commonItems = [
  ['2 قلم جاف أزرق', 1],
  ['قلم أخضر', 1],
  ['قلم رصاص', 1],
  ['ممحاة', 1],
  ['مبراة', 1],
  ['مقص', 1],
  ['لاصق', 1],
  ['لوح', 1],
  ['قلم لوح', 2],
  ['ممسحة', 1],
  ['أقلام زينة 12 لون حجم كبير', 1],
  ['مسطرة 20 صم', 1],
  ['أوراق رسم', 1],
  ['أوراق ملونة', 1],
  ['Rame de papier', 2],
  ['كيس', 1],
  ['صلصال', 1],
  ['Pochette', 1]
];

function presetItem(levelKey, index, name, quantity = 1, section = 'Fournitures communes', subject = '', cover = '', note = '') {
  return {
    id: `preset_${levelKey}_${String(index + 1).padStart(2, '0')}`,
    name,
    quantity,
    section,
    subject,
    cover,
    note,
    order: index
  };
}

function makePreset(levelKey, rows) {
  const commons = commonItems.map(([name, quantity]) => [name, quantity, 'Fournitures communes', '', '', '']);
  return [...commons, ...rows].map((row, index) => presetItem(levelKey, index, ...row));
}

const educationBasic = [
  ['كراس تربية إسلامية عدد 24', 1, 'مجال التربية', 'التربية الإسلامية', 'غلاف وردي', ''],
  ['كراس تربية موسيقية', 1, 'مجال التربية', 'التربية الموسيقية', 'غلاف شفاف', '']
];

const languagesBasic = [
  ['كراس تمارين عدد 48', 1, 'مجال اللغات', 'Français', 'غلاف برتقالي', ''],
  ['كراس محفوظات', 1, 'مجال اللغات', 'Français', 'غلاف برتقالي شفاف', ''],
  ['كراس قسم عدد 24', 1, 'مجال اللغات', 'Français', 'غلاف برتقالي مربعات', ''],
  ['حافظة أوراق', 1, 'مجال اللغات', 'Français', '', ''],
  ['كراس تمارين عدد 48', 1, 'مجال اللغات', 'English', 'غلاف أخضر', ''],
  ['كراس محفوظات', 1, 'مجال اللغات', 'English', 'غلاف أخضر شفاف', ''],
  ['كراس قسم عدد 24', 1, 'مجال اللغات', 'English', 'غلاف أخضر مربعات', '']
];

export const SCHOOL_SUPPLY_PRESETS = {
  '1ere': makePreset('1ere', [
    ['كراس عدد 24 للقسم', 2, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر مربعات', ''],
    ['كراس عدد 24 للتدريب على الإنتاج', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس عدد 48 للمحاولات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس محفوظات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر شفاف', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'لون أحمر', ''],
    ['كراس التمارين عدد 48', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر', ''],
    ['كراس القسم عدد 24', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر مربعات', ''],
    ['كراس الإيقاظ حجم صغير', 1, 'مجال العلوم', 'العلوم', 'غلاف شفاف أصفر', ''],
    ['أعواد / أقراص / نقود مغلفة', 1, 'مجال العلوم', 'العلوم', '', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال العلوم', 'العلوم', 'لون أصفر', ''],
    ...educationBasic,
    ...languagesBasic
  ]),

  '2eme': makePreset('2eme', [
    ['كراس عدد 24 للقسم', 2, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر مربعات', ''],
    ['كراس عدد 24 للتدريب على الإنتاج', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس عدد 48 للمحاولات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس محفوظات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر شفاف', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'لون أحمر', ''],
    ['كراس التمارين عدد 48', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر', ''],
    ['كراس القسم عدد 24', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر مربعات', ''],
    ['كراس الإيقاظ حجم صغير', 1, 'مجال العلوم', 'العلوم', 'غلاف شفاف أصفر', ''],
    ['أعواد / أقراص / نقود مثقبة', 1, 'مجال العلوم', 'العلوم', '', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال العلوم', 'العلوم', 'لون أصفر', ''],
    ...educationBasic,
    ...languagesBasic,
    ['حاملة أوراق 50 صفحة', 1, 'مجال اللغات', 'Français', 'لون برتقالي', '']
  ]),

  '3eme': makePreset('3eme', [
    ['كراس المحاولات عدد 72', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس القسم عدد 24', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس التمارين عدد 48', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر مربعات', ''],
    ['كراس المحفوظات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر شفاف', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'لون أحمر', ''],
    ['كراس التمارين عدد 48', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر', ''],
    ['كراس القسم عدد 24', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر مربعات', ''],
    ['كراس الإيقاظ حجم صغير', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر شفاف', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال العلوم', 'العلوم', 'لون أصفر', ''],
    ...educationBasic,
    ...languagesBasic
  ]),

  '4eme': makePreset('4eme', [
    ['كراس المحاولات عدد 72', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس القسم عدد 24', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس الإنتاج عدد 48', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر مربعات', ''],
    ['كراس المحفوظات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر شفاف', ''],
    ['كراس المطالعة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'لون أحمر', ''],
    ['كراس التمارين عدد 48', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر', ''],
    ['كراس القسم عدد 24', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر مربعات', ''],
    ['كراس هندسة بدون مربعات', 1, 'مجال العلوم', 'العلوم', '', ''],
    ['كراس الإيقاظ حجم كبير', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر شفاف', ''],
    ['حاملة أوراق 50 صفحة', 1, 'مجال العلوم', 'العلوم', 'لون أصفر', ''],
    ...educationBasic,
    ...languagesBasic
  ]),

  '5eme': makePreset('5eme', [
    ['كراس المحاولات عدد 72', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس القسم عدد 24', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['كراس الإنتاج عدد 48', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر مربعات', ''],
    ['كراس المحفوظات', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر شفاف', ''],
    ['كراس المطالعة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'غلاف أحمر', ''],
    ['حاملة أوراق 100 صفحة', 1, 'مجال اللغة العربية', 'اللغة العربية', 'لون أحمر', ''],
    ['كيس', 1, 'مجال اللغة العربية', 'اللغة العربية', '', ''],
    ['كراس التمارين عدد 48', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر', ''],
    ['كراس القسم عدد 24', 2, 'مجال العلوم', 'العلوم', 'غلاف أصفر مربعات', ''],
    ['كراس هندسة حجم كبير', 2, 'مجال العلوم', 'العلوم', 'غلاف أصفر شفاف', 'مربعات / بدون مربعات'],
    ['كراس أنشطة حجم صغير', 1, 'مجال العلوم', 'العلوم', 'غلاف أصفر شفاف', ''],
    ['حاملة أوراق 100 صفحة', 2, 'مجال العلوم', 'العلوم', 'لون أصفر', ''],
    ['أدوات هندسة + بكرة', 1, 'مجال العلوم', 'العلوم', '', ''],
    ['كراس تربية إسلامية عدد 24', 1, 'مجال التربية', 'التربية الإسلامية', 'غلاف وردي', ''],
    ['كراس تربية موسيقية', 1, 'مجال التربية', 'التربية الموسيقية', 'غلاف شفاف', ''],
    ['كراس تربية مدنية عدد 24', 1, 'مجال التربية', 'التربية المدنية', 'غلاف وردي مربعات', ''],
    ['كراس تاريخ وجغرافيا عدد 72', 1, 'مجال التربية', 'التاريخ والجغرافيا', 'غلاف وردي', ''],
    ['كراس تمارين عدد 48', 3, 'مجال اللغات', 'Français', 'غلاف برتقالي', ''],
    ['كراس محفوظات', 1, 'مجال اللغات', 'Français', 'غلاف برتقالي شفاف', ''],
    ['كراس الإنتاج 5×5 مربعات كبيرة', 1, 'مجال اللغات', 'Français', '', ''],
    ['كراس قسم عدد 24', 1, 'مجال اللغات', 'Français', 'غلاف برتقالي مربعات', ''],
    ['حافظة أوراق', 1, 'مجال اللغات', 'Français', '', ''],
    ['كراس تمارين عدد 48', 1, 'مجال اللغات', 'English', 'غلاف أخضر', ''],
    ['كراس محفوظات', 1, 'مجال اللغات', 'English', 'غلاف أخضر شفاف', ''],
    ['كراس قسم عدد 24', 1, 'مجال اللغات', 'English', 'غلاف أخضر مربعات', '']
  ])
};

export const SCHOOL_SUPPLY_NOTICES = [
  'تغلف كل الكتب والكراسات ويكتب الاسم واللقب على جميع الأدوات.',
  'الكتب المدرسية المرخص فيها من قبل وزارة التربية.',
  'كتب اللغات متوفرة بالمدرسة.'
];

export function getSupplyPreset(levelKey) {
  return SCHOOL_SUPPLY_PRESETS[levelKey]
    ? SCHOOL_SUPPLY_PRESETS[levelKey].map((item) => ({ ...item }))
    : [];
}

function normalizeText(value) {
  return String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]/g, '');
}

export function currentSchoolYear(now = new Date()) {
  const year = now.getFullYear();
  const start = now.getMonth() >= 6 ? year : year - 1;
  return `${start}-${start + 1}`;
}

export function normalizeSchoolYear(value) {
  const raw = String(value || '')
    .trim()
    .replace(/[–—/]/g, '-')
    .replace(/\s+/g, '');
  const match = raw.match(/(20\d{2})-(20\d{2}|\d{2})/);
  if (!match) return currentSchoolYear();
  const start = Number(match[1]);
  const end = Number(match[2].length === 2 ? `20${match[2]}` : match[2]);
  if (!Number.isFinite(start) || !Number.isFinite(end)) return currentSchoolYear();
  return `${start}-${end}`;
}

export function schoolYearLabel(value) {
  return normalizeSchoolYear(value).replace('-', '–');
}

export function schoolYearOptions(base = currentSchoolYear()) {
  const start = Number(normalizeSchoolYear(base).slice(0, 4));
  return [-1, 0, 1].map((offset) => {
    const first = start + offset;
    return `${first}-${first + 1}`;
  });
}

export function levelLabel(levelKey) {
  return SUPPLY_LEVELS.find((level) => level.key === levelKey)?.label || levelKey || 'Classe';
}

export function levelKeyFromValue(value) {
  const normalized = normalizeText(value);
  if (!normalized) return '';

  if (normalized.startsWith('preparatoire') || normalized.startsWith('prepa') || normalized === 'prep') return 'preparatoire';

  const prefixes = [
    ['1ere', ['1ere', '1annee', 'premiere', '1re']],
    ['2eme', ['2eme', '2annee', 'deuxieme']],
    ['3eme', ['3eme', '3annee', 'troisieme']],
    ['4eme', ['4eme', '4annee', 'quatrieme']],
    ['5eme', ['5eme', '5annee', 'cinquieme']],
    ['6eme', ['6eme', '6annee', 'sixieme']]
  ];

  for (const [key, values] of prefixes) {
    if (values.some((prefix) => normalized === prefix || normalized.startsWith(prefix))) return key;
  }
  return '';
}

export function levelKeyFromStudent(student) {
  if (!student) return '';
  const candidates = [student.level, student.requestedLevel, student.classLabel, student.className, student.class?.name, student.class?.label, student.classId];
  for (const candidate of candidates) {
    const levelKey = levelKeyFromValue(candidate);
    if (levelKey) return levelKey;
  }
  return '';
}

export function suppliesListId(schoolYear, levelKey) {
  return `${normalizeSchoolYear(schoolYear)}_${levelKey}`;
}
